(() => {
  const newBogosBundleHome = document.querySelector(".js-bogos-bundle-holder");
  function moveBogosBundle() {
    const bogosBundle = document.querySelector("#bogos-bundle-view");

    if (bogosBundle) {
      newBogosBundleHome.append(bogosBundle);
    }
  }

  function waitForElms(selectors) {
    return new Promise((resolve) => {
      let found = false;
      if (selectors.reduce((acc, sel) => document.querySelector(sel) && acc)) {
        return resolve();
      }

      const observer = new MutationObserver((mutations) => {
        if (selectors.reduce((acc, sel) => document.querySelector(sel) && acc)) {
          found = true;
          observer.disconnect();
          resolve();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      setTimeout(() => {
        if (!found) {
          observer.disconnect();
          newBogosBundleHome.classList.add("hidden");
        }
      }, 3000);
    });
  }
  waitForElms([
    "#bogos-bundle-view",
    ".bogos-bundles-widget",
    ".bogos-bundles-widget-header",
    ".bogos-bundles-widget-body",
    ".bogos-bundles-widget-footer",
  ]).then(() => {
    moveBogosBundle();
  });
})();
